import styled from 'styled-components'

export const SliderStyled = styled.div`
  img {
    width: 100%;
    height: 100vh;
  }

  .slick-arrow {
    height: 40px;
    background-color: #fff;
    color: black;
    border-radius: 50%;
    width: 40px;
    opacity: 1;
    margin-inline: 30px;
  }
  .slick-prev::after {
    position: absolute;
    top: 40%;
    left: 39%;
    font-size: 24px;
  }
  .slick-next::after {
    position: absolute;
    top: 39%;
    left: 31%;
    font-size: 24px;
  }
  .slick-slide {
    height: 100vh;
  }
  @media screen and (max-width: 500px) {
    .slick-arrow {
      margin-inline: 0;
    }
  }
`

export const EachSliderStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`
